import { StateCreator } from "zustand";
import { config } from "../lib/config";
import { AvaiableProductsResult } from "../types/AvailableProducts";
import { ResultsSlice } from "./resultsStore";
import { SearchSlice } from "./searchStore";

type AddressState = {
  selectedUseplaceId: number | undefined;
  availableProducts: AvaiableProductsResult | undefined;
};

type AddressActions = {
  setSelectedUseplaceId: (selectedUseplaceId: number) => void;
  resetSelectedUseplace: () => void;
  getAvailableProducts: (selectedUseplaceId: number) => void;
};

export type AddressSlice = AddressState & AddressActions;

const initialState: AddressState = {
  selectedUseplaceId: undefined,
  availableProducts: undefined,
};

export const createAddressSlice: StateCreator<
  SearchSlice & ResultsSlice & AddressSlice,
  [],
  [],
  AddressSlice
> = (set) => ({
  // initial state
  ...initialState,
  // actions

  setSelectedUseplaceId: (selectedUseplaceId: number) =>
    set({ selectedUseplaceId }),
  resetSelectedUseplace: () => set(initialState),
  getAvailableProducts: async (selectedUseplaceId: number) => {
    const res = await fetch(
      `${config.API_URL}/order/availableproducts?q=${selectedUseplaceId}`
    );
    const data = (await res.json()) as AvaiableProductsResult;
    set({ availableProducts: data });
  },
});
